<template>
  <CModal
    :title="title"
    :color="color"
    size="lg"
    :show.sync="showModal"
  >   
    <CRow>
      <CCol md="12">
        <CDataTable
          hover
          striped
          border
          small
          fixed
          :items-per-page="20"
          :items="suppliers"
          :fields="fields"
          :tableFilter="tableFilter"
          pagination
        >
          <template #name="{item}">
            <td class="text-small" style="text-transform: uppercase; padding: 0px 0px 0px 10px;">{{item.name}}</td>
          </template>
          <template #assign="{item}">
            <td class="text-center text-small" style="padding: 0px;">
              <CSwitch           
              :id="'switch-rule-id'+rule_id + 'item-id'+item.id"                   
              class="mx-1"
              color="success"
              :key="`switch-rule-${rule_id}-item-${item.id}-${item.is_assigned ? 1 : 0}`"
              variant="3d"
              v-bind="labelIcon"
              :checked.sync="item.is_assigned"
              @update:checked="val => updateAssignSupplier(item,val)"
            />
            </td>
          </template>
        </CDataTable>         
      </CCol>
    </CRow>  
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>

import store from '../../../store';
import ws from '../../../services/challenges';

export default {
  name: 'AssignSupplierObjectiveModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Asignar Participantes",
      color: "info",
      isEdit: false,
      fields: [
        {key: 'name', label: 'Nombre', _classes: 'text-small'},
        {key: 'assign', label: 'Asignar', _classes: 'text-small'},
      ],
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      },
      suppliers: [],
      link: '',
      item: false,
      rule_id: 0,
      challenge_id: 0,
      
    }
  },
  mounted: async function() {
    this.challenge_id = this.$route.params.challenge_id
  },
  methods: {
    async openModal (rule_id) {
      this.showModal = true;
      this.color = "info";
      this.title = 'Asignar Participantes';
      this.rule_id = rule_id;

      this.loading();
        const response = await ws.getSuppliersObjectives(this.rule_id);

        if(response.type == "success"){
          this.suppliers = response.data.map(s => ({
            ...s,
            // fuerza booleano por si viene como "1"/"0" o 1/0
            is_assigned: Boolean(Number(s.is_assigned))
          }));
        }
      this.loaded();    
    },
    async updateAssignSupplier (item, val) {
      const prev = !val
      this.loading();
        const response = await ws.updateSuppliersObjectives(this.challenge_id,this.rule_id,{supplier_id: item.id});
        if (response.type === 'success') {
          // Alternar manualmente el valor
          // item.is_assigned = !item.is_assigned;
        }
      this.loaded();
    },
    closeModal () {
      this.suppliers = [];
      this.showModal = false;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  },
  computed: {

  },
}
</script>

<style>
.text-small {
  font-size: 10px;
}
</style>